import { UntitledIcon } from '@faceup/icons'
import { ulArrowLeft } from '@faceup/icons/ulArrowLeft'
import { Link, type RouteCallback, useNavigate } from '@faceup/router'
import { Button, Col, Row } from '@faceup/ui-base'
import type { Language } from '@faceup/utils'
import type { ReactNode } from 'react'
import { defineMessages, FormattedMessage, useIntl } from '../../TypedIntl'
import LanguageDropdown from '../LanguageDropdown'

const messages = defineMessages({
  backToHomepage: 'FollowUp.header.backToHomepage',
})

type SimpleHeaderContentProps = {
  isApp: boolean
  isHiddenBackButton: boolean
  homepageLinkCallback: RouteCallback
  logoSlot: ReactNode
  languages: Language[] | null | undefined
  defaultLanguage: Language | undefined
}

export const SimpleHeaderContent = ({
  isApp,
  isHiddenBackButton,
  homepageLinkCallback,
  logoSlot,
  languages,
  defaultLanguage,
}: SimpleHeaderContentProps) => {
  const navigate = useNavigate()
  const { formatMessage } = useIntl()

  return (
    <Row className='w-full justify-between items-center'>
      <Col span={8}>
        {!isApp && !isHiddenBackButton && (
          <>
            <div className='hidden sm:block'>
              <Button
                type='text'
                icon={<UntitledIcon icon={ulArrowLeft} size={24} />}
                onClick={() => navigate(homepageLinkCallback)}
                data-test='button-back-to-homepage'
              >
                <FormattedMessage {...messages.backToHomepage} />
              </Button>
            </div>
            <div className='block sm:hidden'>
              <Link to={homepageLinkCallback}>
                <Button
                  type='text'
                  icon={<UntitledIcon icon={ulArrowLeft} size={24} />}
                  label={formatMessage(messages.backToHomepage)}
                  data-test='button-back-to-homepage'
                />
              </Link>
            </div>
          </>
        )}
      </Col>
      <Col span={8}>
        <div className='flex justify-center'>{logoSlot}</div>
      </Col>
      <Col span={8}>
        <div className='flex justify-end'>
          <div className='hidden md:block'>
            {(languages ?? []).length > 1 && (
              <LanguageDropdown availableLanguages={languages} defaultLanguage={defaultLanguage} />
            )}
          </div>
        </div>
      </Col>
    </Row>
  )
}
